<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 28.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 14 14" style="enable-background:new 0 0 14 14;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#FFFFFF;}
</style>
<path class="st0" d="M9.3,6.1c0,0.6-0.2,1.3-0.6,1.8c-0.4,0.5-0.9,1-1.5,1.2C6.7,9.3,6,9.4,5.4,9.3C4.7,9.2,4.1,8.8,3.7,8.4
	s-0.8-1-0.9-1.7C2.7,6.1,2.7,5.4,3,4.8c0.2-0.6,0.7-1.1,1.2-1.5S5.4,2.8,6,2.8c0.9,0,1.7,0.3,2.3,1C8.9,4.4,9.3,5.2,9.3,6.1z
	 M12.9,13c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1L9.3,10c-1,0.8-2.3,1.3-3.7,1.2
	c-1.3-0.1-2.6-0.7-3.5-1.7c-0.9-1-1.4-2.3-1.3-3.6c0-1.3,0.6-2.6,1.5-3.5c0.9-0.9,2.2-1.5,3.5-1.5c1.3,0,2.6,0.5,3.6,1.3
	c1,0.9,1.6,2.1,1.7,3.5C11.2,7,10.8,8.3,10,9.4l2.9,2.9c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2
	C13,12.9,12.9,12.9,12.9,13z M6,10.3c0.8,0,1.7-0.2,2.3-0.7C9,9.1,9.6,8.4,9.9,7.7c0.3-0.8,0.4-1.6,0.2-2.4C10,4.4,9.6,3.7,9,3.1
	c-0.6-0.6-1.3-1-2.2-1.2S5.2,1.8,4.4,2.2C3.6,2.5,3,3,2.5,3.7S1.8,5.2,1.8,6.1c0,1.1,0.4,2.2,1.2,3S4.9,10.3,6,10.3z"/>
</svg>
